export const FeatureSettingsActionType = Object.freeze({
  SET_FEATURE_SETTINGS: "Feature Settings:: Set Profile Settings",
});
